import transformer from '@/utils/transformer';
import { OutputData, OutputBlockData } from '@editorjs/editorjs';

type Transformer = (block: OutputBlockData) => OutputBlockData;

export const anchorToTargetBlankTransformer: Transformer = block => {
  if (block.type === 'paragraph') {
    block.data.text = block.data.text.replace(
      /<a /g,
      '<a target="_blank" rel="noopener noreferrer" ',
    );
  }
  return block;
};

type LegacyChecklistItem = { text: string; checked: boolean };

export const legacyChecklistToNestedListTransformer: Transformer = block => {
  if (block.type !== 'checklist') return block;

  const rawItems = block.data?.items;
  const legacyItems: LegacyChecklistItem[] = Array.isArray(rawItems)
    ? rawItems
    : [];

  return {
    ...block,
    type: 'nestedList',
    data: {
      style: 'checklist',
      meta: {},
      items: legacyItems.map(({ text, checked }) => ({
        content: String(text ?? ''),
        meta: { checked: !!checked },
        items: [],
      })),
    },
  };
};

const outputDataTransformer = (data: OutputData) => {
  const transformers: Transformer[] = [
    legacyChecklistToNestedListTransformer,
    anchorToTargetBlankTransformer,
  ];
  data.blocks = transformer(data.blocks, transformers);
  return data;
};

export default outputDataTransformer;
